export const HTTP_RESPONSE_CODES = {
  OK: 200,
  UPDATED: 200,
  CREATED: 201,
  NO_CHANGE: 204,
  BAD_INPUT: 400,
  UNAUTHORIZED: 401,
  ACTION_NOT_ALLOWED: 403,
  ENTITY_NOT_FOUND: 404,
  SERVER_ERROR: 500,
};
